import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { useIsClient } from '@grandvisionhq/lib-utils-react';
import { getIconByName } from '../get-icon-by-name.js';

const defaultWidth = 24;
const defaultHeight = 24;
const Icon = (_param)=>{
    var { name ='' , width =defaultWidth , height =defaultHeight , viewBox =`0 0 ${defaultWidth} ${defaultHeight}` , className , style  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "name",
        "width",
        "height",
        "viewBox",
        "className",
        "style"
    ]);
    const isClient = useIsClient();
    const classname = classnames('icon', `icon--${name}`, className);
    // doesn't jump when the icons are loading
    const fallback = /*#__PURE__*/ React.createElement("div", {
        className: classname,
        style: {
            width,
            height
        }
    });
    const IconByName = getIconByName(name);
    if (!IconByName || !isClient) {
        return fallback;
    }
    return /*#__PURE__*/ React.createElement(React.Suspense, {
        fallback: fallback
    }, /*#__PURE__*/ React.createElement(IconByName, swcHelpers.extends({
        style: style,
        viewBox: viewBox,
        width: width,
        height: height,
        className: classname,
        "data-t": rest['data-t'],
        "aria-hidden": 'true',
        role: "img",
        alt: ""
    }, rest)));
};

export { Icon as default };
//# sourceMappingURL=Icon.js.map
